
import { Button } from '@/components/ui/button';
import { Image, AtSign, Paperclip } from 'lucide-react';

const ReplyActions = () => {
  return (
    <div className="flex space-x-2">
      <Button variant="outline" size="sm" className="text-gray-600 dark:text-gray-300 dark:border-gray-700 dark:hover:bg-gray-800">
        <Image className="h-4 w-4 mr-1" />
        Image
      </Button>
      <Button variant="outline" size="sm" className="text-gray-600 dark:text-gray-300 dark:border-gray-700 dark:hover:bg-gray-800">
        <AtSign className="h-4 w-4 mr-1" />
        Mention
      </Button>
    </div>
  );
};

export default ReplyActions;
